<div class="permission-denied-wrapper">
  <h1>Permission Denied</h1>
  <h3>We're sorry, but you do not have access to this page</h3>
  <img src="assets/images/no-no-no.gif">
  <button mat-raised-button (click)="goToDashboard()" color="primary">Go to Dashboard</button>
</div>
